import Timespan from "./Timespan.component.jsx";

export default Timespan;
